import React, { useEffect, useState } from "react";
import { BASE_URL, BASE_IMAGE_URL } from "../../service/apiConfig";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  Select,
  Typography,
  Space,
  Button,
  Table,
  Modal,
  Form,
  Input,
  notification,
  Upload,
  message,
  Card,
  DatePicker,
  InputNumber,
  Row
} from "antd";
import moment from "moment";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import countriesApi from "../../service/countriesApi";
import locationTourApi from "../../service/locationTourService";
// import eventServiceApi from "../../service/locationserviceService";
import eventServiceApi from "../../service/eventService";
import serviceCategoryApi from "../../service/serviceCategoriesApi";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
// import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./management.css";
import draftToHtml from "draftjs-to-html";
import translateApi from "../../service/translateService";
import isEqual from 'lodash/isEqual';
import Utils from "../../components/shares/utils";

// import htmlToDraft from "html-to-draftjs";

const { Option } = Select;
const { TextArea } = Input;

export default function ManagementPage() {
  const deepEqual = isEqual;
  const [eventCategoryId, setEventCategoryId] = useState(0);

  const [isShowUpdateEventCategory, setIsShowUpdateEventCategory] = useState(false);

  const [listServiceCategory, setListServiceCategory] = useState([]);

  const [listCountry, setListCountry] = useState([]);
  // const [listEventCategory, setListServiceCategory] = useState([]);

  const [fileListService, setFileListService] = useState([]);
  const [fileListServiceSubmit, setFileListServiceSubmit] = useState([]);

  const [loading, setLoading] = useState(false);
  const [invalidImage, setInvalidImage] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [form] = Form.useForm();
  const [formService] = Form.useForm();
  const [instroductionContent, setInstroductionContent] = useState("");
  const [language, setLanguage] = useState("vi");
  const [dataChange, setDataChange] = useState(true);
  const [titleData, setTitleData] = useState("");
  const [desData, setDesData] = useState("");
  const [loadingTranslate, setLoadingTranslate] = useState(false);
  const [dataTranslate, setDataTranslate] = useState();
  const [lastData, setLastData] = useState({});

  const [editorStateInstroduction, setEditorStateInstroduction] = useState(
    () => {
      const blocksFromHTML = convertFromHTML(instroductionContent);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      return EditorState.createWithContent(contentState);
    }
  );

  useEffect(() => {
    getAllServiceCategory();
  }, []);

  const onFormValueChange = () =>{
    setDataChange(true)
  }

  const getAllServiceCategory = () => {
    serviceCategoryApi.getAll().then((res) => {
      setListServiceCategory(res.data);
    });
  };

  const deleteEvent = () => {
    serviceCategoryApi.delete(eventCategoryId).then((res) => {
      notification.success({ message: `Delete event success` });
      getAllServiceCategory();
      setOpenDeleteDialog(false);
    }).catch((err) => {
      notification.error({ message: err.response.data.message });
      setOpenDeleteDialog(false);
    });
  };

  const openModalEventCategory = (id) => {
    setIsShowUpdateEventCategory(true);
    setEventCategoryId(id);
    if (id) {
      serviceCategoryApi.getByIdOnly(id).then((res) => {
        formService.setFieldsValue({
          title: res.data.title,
          textContentId: res.data.textContentId,
          description: res.data.description,
          ordering: res.data.ordering,
        });
        setDesData(res.data.description);
        setTitleData(res.data.title);
      });
    }
  };

  const onCloseModalEventCategory = () => {
    setIsShowUpdateEventCategory(false);
    setFileListService([]);
    setLanguage("vi");
    setFileListServiceSubmit([]);
    formService.setFieldsValue({
      title: "",
      textContentId: "",
      description: "",
      ordering: ''
    });
  };

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 20 },
  };

  const openDeleteService = (id) => {
    setEventCategoryId(id);
    setOpenDeleteDialog(true);
  };
  const columnsService = [
    {
      title: "Loại hình dịch vụ",
      dataIndex: "title",
      key: "title",
      width: 300
    },
    {
      title: "Mô tả",
      dataIndex: "description",
      key: "description",
      width: 800
    },
    {
      title: "Sắp xếp",
      dataIndex: "ordering",
      key: "ordering",
      width: 100
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openModalEventCategory(_.id)}
          >
            Sửa
          </Button>
          <Button
            type="danger"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openDeleteService(_.id)}
          >
            Xóa
          </Button>
        </Space>
      ),
    },
  ];

  const onFinishHandle = (values) => {
    if (eventCategoryId !== 0) {
      serviceCategoryApi.updateById(eventCategoryId, values).then((res) => {
        notification.success({ message: "Cập Nhật Loại hình dịch vụ Thành công" });
        getAllServiceCategory();
        onCloseModalEventCategory();

      }).catch((err) => {
        notification.error({ message: err.response.data.message });
      });
    } else {
      serviceCategoryApi.create(values).then((res) => {
        notification.success({ message: "Tạo Loại hình dịch vụ Thành công" });
        form.setFieldsValue({
          title: "",
          textContentId: '',
          description: "",
        });
        getAllServiceCategory();
        setIsShowUpdateEventCategory(false);
        onCloseModalEventCategory();
      });
    }
  };
///
const onFinishHandleServiceCategory = (values) => {
  if (eventCategoryId !== 0) {
    if (language === "vi") {
      serviceCategoryApi.updateById(eventCategoryId, values).then((res) => {
        notification.success({ message: "Update service category success" });
        let newData = {}
        newData[language] = {}
        newData[language].title = formService.getFieldValue("title")
        newData[language].description = formService.getFieldValue("description")
        setLastData(newData)
        setDataChange(false)
        getAllServiceCategory();
      });
    } else  {
      var temp={}
      temp[language] =
       {
         title: values.title,
         description: values.description,
       }
      // const temp={
      //   'en':{
      //     title: values.title,
      //     description: values.description,
      //   }
      // }
      const data = { textTranslate: JSON.stringify(temp) };
      serviceCategoryApi.updateById(eventCategoryId, data).then((res) => {
        notification.success({ message: "Update service category success" });
        let newData = {}
        newData[language] = {}
        newData[language].title = formService.getFieldValue("title")
        newData[language].description = formService.getFieldValue("description")
        setLastData(newData)
        setDataChange(false)
        getAllServiceCategory();
      });
    }
  } else {
    serviceCategoryApi.create(values).then((res) => {
      notification.success({ message: "Create service category success" });
      getAllServiceCategory();
      setIsShowUpdateEventCategory(false);
      onCloseModalEventCategory();
    });
  }
};
///
  const onSelectLanguage = (value) =>  {
    onHandleTranslate(eventCategoryId, value)
    setDataChange(true)
    setLanguage(value);
  }

  const onChangeTitle = (value) => {
    setTitleData(value.target.value);
  };
  const onChangeDes = (value) => {
    setDesData(value.target.value);
  };

  const onHandleTranslate = (id, forceLang) => {
    setLoadingTranslate(true);
    const textData = {
      title: titleData,
      description: desData,
    };
    const data = {
      text: textData,
      language: forceLang ? forceLang:language,
      type: "serviceCategory",
      id: id,
    };
    translateApi.translate(data).then((res) => {
      const textTranslate = res.data
      if (textTranslate.length > 0) {
        setLoadingTranslate(false);
        const newdata = []
        textTranslate.map((e) => {
          if (e.language == language) {
            formService.setFieldsValue({
              title: e.title,
              description: e.description,
            });
          }
        })
      } else {
        setLoadingTranslate(false);
        setDataTranslate(dataTranslate);
        let newFormData = {
          title: res.data.title,
          description: res.data.description,
        }
        setDataChange(false)
        if (!deepEqual(newFormData, lastData[data.language])){
          setDataChange(true)
        }
        formService.setFieldsValue({
          title: res.data.title,
          description: res.data.description,
        });
      }

    });
  };

  return (
    <>
      <Card
        title={
          <Typography style={{ textAlign: "center" }}>
           Quản lý Loại Hình Dịch Vụ
          </Typography>
        }
        extra={
          <Button
            type="primary"
            style={{
              borderRadius: "8px",
            }}
            onClick={() => {
              setIsShowUpdateEventCategory(true);
            }}
          >
            Tạo Loại Hình Dịch Vụ
          </Button>
        }
      >
        <Table
          columns={columnsService}
          dataSource={listServiceCategory}
          bordered
        />

        <Modal
          title={eventCategoryId !== 0 ? "Cập nhật loại hình Dịch vụ" : "Tạo loại hình Dịch vụ"}
          visible={isShowUpdateEventCategory}
          onCancel={() => {
            setEventCategoryId(0);
            onCloseModalEventCategory();
            setFileListServiceSubmit([]);
          }}
          footer={[
            <>
              <Button
                size="small"
                onClick={() => {
                  onCloseModalEventCategory();
                }}
              >
                Đóng
              </Button>
              <Button
                size="small"
                className="btn btn-primary"
                type="primary"
                form="CU-tour"
                key="submit"
                htmlType="submit"
                disabled = {!dataChange}
              >
                Hoàn Thành
              </Button>
            </>,
          ]}
        >
          <>
          {eventCategoryId!=0&&<Row justify="end" style={{marginBottom:"20px"}}>
                <Select
                  onChange={onSelectLanguage}
                  defaultValue="vi"
                  value={language}
                >
                  <Option value="vi">Tiếng Việt</Option>
                  <Option value="en">English</Option>
                  <Option value="fr">French</Option>
                  <Option value="zh-CN">Chinese</Option>
                  <Option value="ko">Korean</Option>
                  <Option value="de">German</Option>
                </Select>
                <Button
                  type="primary"
                  onClick={() => {
                    onHandleTranslate(eventCategoryId);
                  }}
                  loading={loadingTranslate}
                >
                  Dịch
                </Button>
              </Row>}
            {/* //// */}
            <Form
              {...layout}
              form={formService}
              name="CU-tour"
              onFinish={onFinishHandleServiceCategory}
              onValuesChange = {onFormValueChange}
            >
              <Form.Item
                name="title"
                label="Tên"
                rules={[{ required: true }]}
                onChange={onChangeTitle}
              >
                <Input size="large" />
              </Form.Item>

              <Form.Item
                name="ordering"
                label="Thứ tự"
              >
                <InputNumber size="large" />
              </Form.Item>

              <Form.Item name="description" label="Mô tả" onChange={onChangeDes} >
                <TextArea rows={4} />
              </Form.Item>
            </Form>
          </>
        </Modal>
      </Card>
      <Modal
        visible={openDeleteDialog}
        onOk={deleteEvent}
        onCancel={() => {
          setEventCategoryId(0);
          setOpenDeleteDialog(false);
        }}
        title={`Xóa loại hình dịch vụ`}
      >
        Bạn có muốn xóa loại hình dịch vụ này?
      </Modal>
    </>
  );
}
